import React from "react";

const CheckmarkIcon = ({ color = null }) => (
	<svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6.24453 10.6067L2.04453 6.40674L0.644531 7.80674L6.24453 13.4067L18.2445 1.40674L16.8445 0.00674438L6.24453 10.6067Z" fill={color} />
	</svg>
);

export default CheckmarkIcon;
